import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Histogram } from '@/entities/histogram';
import { TABLE_MODE, TableSchema } from '@/shared/lib/table';

import { createHistogramColumns } from '../helpers/create-histogram-columns';
import { histogramsTableFeatures } from './histograms.table-config';

type UseHistogramsTableSchemaParams = {
	onView: (id: string) => void;
	onDelete: (id: string) => void;
	histogramId: string;
};

export const useHistogramsTableSchema = ({
	onView,
	onDelete,
	histogramId,
}: UseHistogramsTableSchemaParams): TableSchema<Histogram, never> => {
	const { t } = useTranslation('tables');

	const columns = useMemo(
		() => createHistogramColumns({ translate: t, onView, onDelete, histogramId }),
		[t, onView, onDelete, histogramId],
	);

	return useMemo(
		() => ({
			...histogramsTableFeatures,
			mode: TABLE_MODE.SERVER,
			columns,
		}),
		[columns],
	);
};
